module.exports = __webpack_public_path__ + "static/assets/1375dd31e116661bffcda557020a5597.png";